import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import { OutDesignSelectorElement } from "./OutDesignSelectorElement";

OutDesignSelectorElement;

@customElement("od-footer")
export class OutDesignFooter extends LitElement {

    static styles = css`
    :host {
        display: block;
        width: -moz-available;
        width: stretch;
        box-sizing: border-box;
        border-top: solid 3px lightgray;
        background: white;
        padding: 0.5em 1rem;
    }
    `

    protected render() {
        return html`<od-selector></od-selector>`;
    }
}